import api from "@api";
import { components } from "@api/schema";
import { ID } from "@types";

export type IService = components["schemas"]["service"];

export const API_PATH = "services";

export const getService = (id: ID) => {
  return api.get<undefined, IService>([API_PATH, String(id)].join("/"));
};
